<!-- src/components/VideoStats.vue -->
<template>
  <v-container fluid>
    <v-card style="width: 100%">
      <v-card-title class="title-option">Video Statistics</v-card-title>
      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="videoTableData"
          :items-per-page="5"
          class="elevation-1"
          @click:row="openDialog"
        >
          <template v-slot:[`item.clicks`]="{ item }">
            {{ item.clicks }}
          </template>
        </v-data-table>

        <v-dialog v-model="dialog" width="1200">
          <v-card style="width: 100%">
            <v-card-title class="title-option">{{
              selectedVideo.title
            }}</v-card-title>
            <v-card-text>
              <apexchart
                type="pie"
                height="300"
                :options="pieOptions"
                :series="pieSeries"
              ></apexchart>
              <v-data-table
                :headers="detailHeaders"
                :items="selectedVideo.entries"
                :items-per-page="5"
                class="elevation-1"
              >
                <template v-slot:[`item.date`]="{ item }">
                  {{ formatDateTime(item.date).datePart }},
                  {{ formatDateTime(item.date).timePart }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    videoStats: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      selectedVideo: null,
      tableHeaders: [
        { title: "Video Title", value: "title" },
        { title: "Clicks", value: "clicks" },
      ],
      detailHeaders: [
        { title: "IP", value: "ip" },
        { title: "Location", value: "location" },
        { title: "Time", value: "date" },
      ],
      pieOptions: {
        chart: { type: "pie" },
        labels: [],
        colors: [
          "#767676",
          "#726f5d",
          "#b7947e",
          "#d9d9d9",
          "#4c3e34",
          "#fefbe7",
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.config.labels[opts.seriesIndex];
          },
          style: {
            fontSize: "14px",
            fontFamily: "Copperplate",
            fontWeight: "bold",
            colors: ["#FFF"],
          },
        },
      },
      pieSeries: [],
    };
  },
  computed: {
    videoTableData() {
      const videoMap = {};
      this.videoStats.forEach((stat) => {
        if (!videoMap[stat.video_url]) {
          videoMap[stat.video_url] = {
            title: stat.video_title,
            clicks: 0,
            entries: [],
          };
        }
        videoMap[stat.video_url].clicks += 1;
        videoMap[stat.video_url].entries.push({
          ip: stat.ip_address,
          location:
            JSON.parse(stat.geo_location).city +
            ", " +
            JSON.parse(stat.geo_location).country,
          date: stat.request_time, // Add the date to the entries
        });
      });
      return Object.values(videoMap).sort((a, b) => b.clicks - a.clicks);
    },
  },
  methods: {
    formatDateTime(timestamp) {
      // Day with suffix
      const date = new Date(timestamp);

      const day = date.getDate();
      let suffix = "th";
      if (day % 10 === 1 && day !== 11) suffix = "st";
      else if (day % 10 === 2 && day !== 12) suffix = "nd";
      else if (day % 10 === 3 && day !== 13) suffix = "rd";

      // Month name
      const month = date.toLocaleString("en-US", { month: "long" });
      // Year
      const year = date.getFullYear();
      // Time (12-hour format)
      const timeString = date.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });

      // Return them separately
      return {
        datePart: `${month} ${day}${suffix} ${year}`, // e.g. "February 13th 2025"
        timePart: timeString, // e.g. "09:52 AM"
      };
    },
    openDialog(event, { item }) {
      this.selectedVideo = item;
      this.pieOptions.labels = [
        ...new Set(item.entries.map((entry) => entry.location)),
      ];
      this.pieSeries = this.pieOptions.labels.map(
        (label) =>
          item.entries.filter((entry) => entry.location === label).length
      );
      this.dialog = true;
    },
  },
};
</script>
